import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    mapProp: 'map',
    name: '分析数据表',
    type: 'AO_DT',
}
